import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"align":"center","justify":"center","min-width":"35vw","max-width":"80vw","max-height":"85vh","outlined":""}},[_c(VCardTitle,{staticStyle:{"background-color":"#d2d7e1"}},[_c(VListItem,[_c(VListItemTitle,[_c('h2',[_vm._v(_vm._s(_vm.$t('title_FullTradeImage')))])]),_c(VSpacer),_c(VListItemAction,[_c(VIcon,{staticClass:"icon",attrs:{"icon":""},on:{"click":_vm.close}},[_vm._v("fa-times")])],1)],1)],1),_c(VCardText,{staticClass:"pa-0",staticStyle:{"background-color":"#111111"}},[_c(VImg,{attrs:{"max-width":"80vw","max-height":"75vh","contain":"","src":_vm.tradeImage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }